// extracted by mini-css-extract-plugin
export default {"careLocationError":"careLocationError"};